module.exports = __webpack_public_path__ + "static/media/proj14.13e3c739.PNG";